/* Remove empty supplier specification rows from the customer-facing description. */
function ccCleanSpecifications(root = document) {
  root.querySelectorAll('#cc-product-description table').forEach(table => {
    table.querySelectorAll('tr').forEach(row => {
      const text = row.textContent.toLowerCase();
      if (/non spécifi|non précisé|non renseigné|not specified|not provided|à confirmer/.test(text)) row.remove();
    });
    if (!table.querySelector('td')) table.remove();
  });
}
ccCleanSpecifications();
const ccHeader = document.querySelector('.section-header');
if (ccHeader) {
  const updateGalleryOffset = () => document.documentElement.style.setProperty('--cc-header-height', `${ccHeader.getBoundingClientRect().height}px`);
  updateGalleryOffset();
  new ResizeObserver(updateGalleryOffset).observe(ccHeader);
}
document.addEventListener('shopify:section:load', event => ccCleanSpecifications(event.target));
